// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from hide.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function HideIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="m1.613.21.094.083 14 14a1 1 0 0 1-1.32 1.497l-.094-.083-14-14A1 1 0 0 1 1.613.21Zm.583 4.845a1 1 0 0 1 .292 1.384C2.165 6.935 2 7.46 2 8c0 2.123 2.628 4 6 4 .22 0 .44-.008.657-.024a1 1 0 0 1 .147 1.994c-.266.02-.534.03-.804.03-4.36 0-8-2.6-8-6 0-.937.283-1.84.812-2.653a1 1 0 0 1 1.384-.292ZM8 2c4.36 0 8 2.6 8 6 0 .937-.283 1.84-.812 2.653a1 1 0 0 1-1.676-1.092C13.835 9.065 14 8.54 14 8c0-2.123-2.628-4-6-4-.22 0-.44.008-.657.024a1 1 0 1 1-.147-1.994C7.462 2.01 7.73 2 8 2Z"
      />
    </svg>
  );
}
